/* eslint-disable react/react-in-jsx-scope */
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import AxiosInterceptor from "./axios/InterceptorComponent";
import store from "./redux/store";
import "./style-main.css";
import { useEffect } from "react";
import AudioPermission from "./hooks/AudioPermission";

// Function to remove the backdrop element
const removeBackdrop = () => {
  const backdrop = document.querySelector(".hs-overlay-backdrop");
  if (backdrop) {
    backdrop.remove();
  }
};

// Use an effect to call the removeBackdrop function
const RemoveBackdropEffect = () => {
  useEffect(() => {
    removeBackdrop();
  }, []);

  return null;
};


const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter>
        <AudioPermission />
          <AxiosInterceptor />
          <RemoveBackdropEffect />
          <App />
        </BrowserRouter>
      </Provider>
    </StrictMode>
  );
}
